import { viewportDimensions, getElementOffset } from '/helpers/window'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Functionality for homepage scolling
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

export default function() {
	const $html = document.querySelector('html')
	const $homeStats = document.querySelector('.home-stats .items')
	const $homeSocial = document.querySelector('.home-social-blocks')

	let windowHeight = viewportDimensions().height
	// let isMobileView = viewportDimensions().width < _MEDIA_SMALL ? true : false
	let homeStatsOffset = getElementOffset($homeStats)
	let homeSocialOffset = getElementOffset($homeSocial)

	window.addEventListener('scroll', _.throttle(() => {
		const scrollTop = window.pageYOffset
		if (scrollTop > homeStatsOffset - windowHeight - 200) {
			$html.classList.add('home-slant-1-animation')
		}
		if (scrollTop > homeStatsOffset - (windowHeight / 4 * 3)) {
			$html.classList.add('home-stats-animation')
		}
		if (scrollTop > homeSocialOffset - windowHeight) {
			$html.classList.add('home-slant-2-animation')
		}
		if (scrollTop > homeSocialOffset - (windowHeight / 2)) {
			$html.classList.add('home-social-animation')
		}
	}, 10))
	window.addEventListener('resize', () => {
		windowHeight = viewportDimensions().height
		// isMobileView = viewportDimensions().width < _MEDIA_SMALL ? true : false
		homeStatsOffset = getElementOffset($homeStats)
		homeSocialOffset = getElementOffset($homeSocial)
	})
}
